$(document).ready(function() {
    // Override countDown
    window.countDown = function(count) {
        // Theme nyelvi változók (vagy manuális magyar szöveg)
        var countdownText = "Ez a felugró ablak automatikusan bezáródik";
        var secondsText = "másodperc";

        if (count > 0) {
            if(count > 1) 
                $(".countDiv").html(countdownText + " <span>"+count+"</span> " + secondsText);
            else 
                $(".countDiv").html(countdownText + " <span>"+count+"</span> " + secondsText);
            setTimeout(function() { window.countDown(count-1); }, 1000);
        } else {
            ajaxCartHide();
        }
    };

    console.log("Custom countDown override active.");
});
